import React from 'react';
import { Box, createStyles, makeStyles } from '@material-ui/core';
import { FindATimeResponse } from '@data/findATime/types/FindATimeResponse';
import { ResultRow } from '@components/RequestForm/FindATime/FindATimeResults/Results/ResultRow';
import { AvailableTimeOption } from '@data/findATime/types/AvailableTimeOption';

const useStyles = makeStyles(() =>
	createStyles({
		root: {
			display: 'flex',
			flexDirection: 'column',
		},
	}),
);

interface ResultsProps {
	data: FindATimeResponse;
	handleSelectTime: (time: AvailableTimeOption, timeSlotId: string, date: Date) => void;
}

export const Results: React.FC<ResultsProps> = ({ data, handleSelectTime }) => {
	const classes = useStyles();

	const ResultRows = data.map((availableDateOption) => {
		return <ResultRow key={availableDateOption.date} option={availableDateOption} handleSelectTime={handleSelectTime} />;
	});

	return <Box className={classes.root}>{ResultRows}</Box>;
};
